/**
 * Smooth desktop mega-menu hover for Shop / Company.
 * Single controller — no competing listeners, short intent delay, no flicker.
 */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var openTimer = null;
  var closeTimer = null;
  var active = null;
  var bound = false;

  function menus() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.header__inline-menu details.mega-menu')
    );
  }

  function clearTimers() {
    window.clearTimeout(openTimer);
    window.clearTimeout(closeTimer);
    openTimer = null;
    closeTimer = null;
  }

  function closeAll(except) {
    menus().forEach(function (details) {
      if (except && details === except) return;
      details.removeAttribute('open');
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });
  }

  function openMenu(details) {
    if (!DESKTOP.matches || !details) return;
    clearTimers();
    closeAll(details);
    details.setAttribute('open', '');
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
    active = details;

    var header = document.querySelector('.header-wrapper');
    if (header) header.preventHide = true;
  }

  function scheduleClose(details) {
    clearTimers();
    closeTimer = window.setTimeout(function () {
      if (!DESKTOP.matches) return;
      if (details && details.matches(':hover')) return;
      details.removeAttribute('open');
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
      if (active === details) active = null;

      var header = document.querySelector('.header-wrapper');
      if (header && !document.querySelector('.header__inline-menu details.mega-menu[open]')) {
        header.preventHide = false;
      }
    }, 140);
  }

  function onEnter(event) {
    if (!DESKTOP.matches) return;
    var details = event.currentTarget;
    clearTimers();
    openTimer = window.setTimeout(function () {
      openMenu(details);
    }, 35);
  }

  function onLeave(event) {
    if (!DESKTOP.matches) return;
    scheduleClose(event.currentTarget);
  }

  function onSummaryClick(event) {
    if (!DESKTOP.matches) return;
    // Avoid click toggling closed while the pointer is still over the item
    event.preventDefault();
    var details = event.currentTarget.closest('details.mega-menu');
    if (!details) return;
    if (details.hasAttribute('open')) {
      // Keep open on click; navigation happens via panel links
      openMenu(details);
    } else {
      openMenu(details);
    }
  }

  function bind() {
    if (bound) return;
    var list = menus();
    if (!list.length) return;
    bound = true;

    list.forEach(function (details) {
      details.addEventListener('mouseenter', onEnter);
      details.addEventListener('mouseleave', onLeave);

      var summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', onSummaryClick);
      }
    });

    // Close when pointer leaves the whole header chrome
    var shell = document.querySelector('.header-wrapper') || document.querySelector('.header');
    if (shell) {
      shell.addEventListener('mouseleave', function () {
        if (!DESKTOP.matches) return;
        clearTimers();
        closeAll();
        active = null;
        shell.preventHide = false;
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        clearTimers();
        closeAll();
        active = null;
      }
    });
  }

  function init() {
    if (DESKTOP.matches) bind();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof DESKTOP.addEventListener === 'function') {
    DESKTOP.addEventListener('change', function () {
      if (DESKTOP.matches) {
        bind();
      } else {
        clearTimers();
        closeAll();
        active = null;
      }
    });
  }
})();
